import UsagiDetector from './class/usagi-detector.js';
window.DETECT = new UsagiDetector({
	deviceChange : true
});